import React, { useContext } from 'react';
import type { FlowAction } from '~/graphql/types';
import useErrorReporter from '~/hooks/useErrorReporter';

type ActionContextType = {
  actionId: string;
  actionType: FlowAction;
};

export const ActionContext = React.createContext<ActionContextType | null>(
  null,
);

const useActionContext = (): ActionContextType => {
  const reporter = useErrorReporter();
  const context = useContext(ActionContext);

  if (context === null) {
    const err = new Error(
      `Action context should be set before using useActionContext but it wasn't`,
    );
    reporter.captureException(err, 'fatal');

    throw err;
  }

  return context;
};

export default useActionContext;
